import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/warehouse/consumable/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/warehouse/consumable/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/warehouse/consumable/updateStatus', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/warehouse/consumable/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/warehouse/consumable/update', params,options);
